// extracted by mini-css-extract-plugin
export default {"root":"DurationRowBanner-root_zN85T"};